/* tslint:disable:no-trailing-whitespace import-spacing no-inferrable-types typedef-whitespace */

import {
  Component,
  OnInit                       } from '@angular/core';
import { Router                } from '@angular/router';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators                   } from '@angular/forms';
import { first                 } from 'rxjs/operators';

import { UserService           } from '@/services/user.service';
import { AlertService          } from '@/services/alert.service';

import { Logger }                from '@/util/logger';

/**
 *
 * @class RegisterComponent
 *
 * @brief we show the registration page when new users want to sign up.
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      March 2020
 *
 */

@Component({
  templateUrl: 'register.component.html'
})
export class RegisterComponent implements OnInit {

  /** use a rand background image for the page */
  public backgrounds: string[] = ['cnh-01.png', 'cnh-02.png', 'cnh-03.png', 'cnh-04.png'];
  public background: string    = '';

  /** form validation */
  public registerForm: UntypedFormGroup;

  /** flag to tell the form when we are processing */
  public loading:      boolean   = false;

  /* flag to tell the form that we completed a request */
  public submitted:    boolean   = false;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private router:      Router,
    private userService: UserService,
    private alerts:      AlertService
  ) {

    /* pick a random background */

    this.background = this.backgrounds[Math.floor(Math.random() * this.backgrounds.length)];

    Logger.debug('[Register]', 'constructing...');
  }

  /** on setup of the page, create our form validation ... */
  ngOnInit(): void {
    this.registerForm = this.formBuilder.group({
      firstName: ['', Validators.required],
      lastName:  ['', Validators.required],
      username:  ['', Validators.required],
      email:     ['', [Validators.required, Validators.email ]],
      password:  ['', [Validators.required, Validators.minLength(6)]]
    });
  }

  /* easy access to form fields */
  get f() {
    return this.registerForm.controls;
  }

  onSubmit(): void {

    this.submitted = true;

    /* did they fill everything in? */

    if (this.registerForm.invalid) {

      return;
    }

    this.loading = true;

    Logger.debug('[Register] trying to register: ', this.registerForm.value);

    this.userService.register(this.registerForm.value)
      .pipe(first())
      .subscribe(
        data => {

          this.alerts.success('Registration successful', {keepAfterRouteChange: true});

          Logger.debug('[Register] registered! ', data);

          this.router.navigate(['/login']);
        },
        error => {

          this.alerts.error(error.error.message, {autoClose: true});

          Logger.error('[Register] authentication error: ', error.error.message);

          this.loading = false;
        });
  }
}
